import { render } from "./BtnAddWaitingListSchedule.vue?vue&type=template&id=689f1a57"
import script from "./BtnAddWaitingListSchedule.vue?vue&type=script&lang=js"
export * from "./BtnAddWaitingListSchedule.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__